<style scoped lang="scss">
@import "../style/color";
.public {
  @include public(248px);
  .noborder {
    border: 0;
    padding: 0;
    .public-ul-li {
      width: 200px;
      margin-right: 12px;
      margin-top: 0;
      margin-bottom: 12px;
      position: relative;
    }
    .public-ul-li-pictrue {
      width: 200px;
    }
    .img {
      width: 200px;
      height: 200px;
    }
  }
  .pruduct-discription-similar {
    margin-top: 5px;
    // margin-top: 3px;
  }
  .pruduct-discription {
    &-origin {
      margin-top: 0px;
      font-family: "EperFontLight";
    }
    &-brandName {
      font-size: 14px;
      font-weight: 600;
      color: #000000;
      font-family: "EperFontLight";
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      height: 28px;
    }
    &-name {
      font-family: "EperFontLight";
      &:hover {
        text-decoration: underline;
      }
    }
    &-remiand {
      font-size: 14px;

      color: $c_ccc;
      // line-height: 1.3 !important;
      line-height: 24px;
    }
    &-similar {
      width: 100%;
      height: 28px;
      text-align: center;
      line-height: 28px;
      color: #393939;
      border: 1px solid #303030;
      border-radius: 15px;
      border-radius: 14px;
      font-size: 14px;
    }
  }
}
.no_ddeliver {
  width: 100%;
  height: 46px;
  position: absolute;
  left: 0;
  top: 74px;
  font-size: 14px;
  font-family: "EperFontBold";
  color: #fff;
  display: -webkit-flex;
  justify-content: center; /*水平居中*/
  align-items: center; /*垂直居中*/
  background: rgba($color: #000000, $alpha: 0.2);
  .no_deliver_msg {
    text-align: center;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    line-height: 16px;
  }
}
.similarPro {
  position: absolute;
  top: 338px;
  left: -214px;
  width: 900px;
  // height: 536px;
  border: 1px solid $c_6DB;
  border-radius: 20px;
  background: #fff;
  z-index: 99;
  padding: 26px 20px 30px 20px;
  .green-arrow {
    position: absolute;
    left: 296px;
    width: 0px;
    height: 0px;
    content: "";
    top: -20px;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid $c_6DB;
    border-left: 10px solid transparent;
  }
  .white-arrow {
    position: absolute;
    left: 297px;
    width: 0px;
    height: 0px;
    content: "";
    top: -17px;
    border-top: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 9px solid #fff;
    border-left: 9px solid transparent;
    z-index: 1;
  }
  .similar-close {
    position: absolute;
    right: 10px;
    top: 14px;
    width: 23px;
    height: 23px;
    cursor: pointer;
    img {
      width: 23px;
      height: 23px;
    }
  }
  .title {
    text-align: center;
    font-size: 16px;
    margin-bottom: 10px;
    font-family: "EperFontLight";
  }

  .similar-product {
    width: 100%;
    margin-bottom: 30px;
    .similar-item {
      width: 206px;
      height: 414px;
      margin-right: 10px;
      background: $c_f7f;
      position: relative;
      .similar-img-box {
        width: 100%;
        height: 204px;
        position: relative;
        .low-price {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 77;
          .ch_img {
            width: 55px;
            height: auto;
          }
        }

        // .discount {
        //   position: absolute;
        //   right: 10px;
        //   bottom: 30px;
        //   height: 36px;
        //   z-index: 77;
        //   .discount_img {
        //     width: 71px;
        //     height: 36px;
        //   }
        // }
        .quality {
          position: absolute;
          width: 160px;
          height: 23px;
          bottom: 0;
          left: 50%;
          z-index: 77;
          margin-left: -75px;
          .quality_img {
            width: 160px;
            height: auto;
          }
        }

        .limittime {
          position: absolute;
          left: 6px;
          bottom: 28px;
          height: 21px;
          z-index: 77;
          .limittime_img {
            width: 80px;
            height: 21px;
          }
        }
        .exclusive {
          position: absolute;
          right: 0;
          bottom: 30px;
          height: 46px;
          z-index: 76;
          .exclusive_img {
            width: 100px;
            height: 46px;
          }
        }
      }
      .icon {
        position: absolute;
        right: 0;
        top: 0;
        .img {
          width: 27px;
          height: 27px;
          float: right;
          margin: 6px 6px 0 0;
        }
      }
      .similar-img {
        width: 100%;
        height: 204px;
        background: pink;
      }
      .similar-name {
        font-size: 14px;
        min-height: 44px;
        padding: 0 16px;
        box-sizing: border-box;
        @include ellipsisMore(2);
      }
      .similar-chandi {
        padding: 0 16px;
        box-sizing: border-box;
        margin-top: 20px;
        font-size: 12px;
      }
      .similar-price {
        font-size: 14px;
        padding-left: 16px;
        box-sizing: border-box;
        color: $c_6DB;
        margin-top: 10px;
      }
      .similar-shopcart {
        position: absolute;
        right: 18px;
        bottom: 18px;
        width: 32px;
        height: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .similar-item:nth-child(4) {
      margin-right: 0;
    }
  }
  .bottom-title {
    font-size: 16px;
    text-align: center;
    font-family: "EperFontLight";
  }
  .remindBtn {
    margin: 0 auto;
    width: 164px;
    height: 30px;
    border-radius: 15px;
    margin-top: 26px;
    color: #fff;
    background: $c_6DB;
    font-size: 14px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
}
.deleteCollect {
  position: absolute;
  left: 0px;
  top: 0;
  font-size: 24px;
  z-index: 100;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-family: "EperFontBold";
  cursor: pointer;
}
.enQuality {
  position: absolute;
  width: 200px !important;
  height: 23px;
  bottom: 0;
  left: 38% !important;
  z-index: 77;
  margin-left: -75px;
  .quality_img {
    width: 200px !important;
    height: auto;
  }
}
.biaoshi {
  // position: absolute;
  // top: 5px;
  // left: 10px;
  padding: 5px;
  box-sizing: border-box;
}
.bsSize {
  width: 93px;
  height: 30px;
}
.icon_js {
  // position: absolute;
  // left: 0px;
  // top: 72px;
}
.icon_js .js_img {
  width: 38px;
}
.js_top {
  top: 77px;
}
.ellipsis {
  white-space: nowrap; /*内容超宽后禁止换行显示*/
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /*文字超出部分以省略号显示*/
  color: #6fbf59 !important;
  font-size: 12px !important;
  font-weight: normal !important;
}
.pruduct-discription-prompt {
  // color:#6FBF59 !important;
}

.low-pricet {
  .ch_img {
    width: 55px;
    height: auto;
  }
}
.newbox {
  width: 100px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
}
</style>
<template>
  <div class="pruduct">
    <div class="public" ref="publicRef" style="position: relative">
      <ul
        class="public-ul clearfix"
        :class="{ noborder: !hasBorder }"
        ref="ulRef"
      >
        <RadioGroup v-model="ProductID" @on-change="changeGiftProduct">
          <li
            class="public-ul-li"
            ref="liRef"
            v-for="(item, k) in productList"
            :key="k"
          >
            <div
              class="public-ul-li-pictrue"
              @click="toDetail(item)"
              :title="item.ProductName"
              @mouseover="showMorePic(k)"
              @mouseleave="hideMorePic(k)"
            >
              <img
                class="img block"
                v-if="
                  !fromHomeSale &&
                  item.showMore &&
                  item.ImgUrlList &&
                  item.ImgUrlList.length > 1
                "
                :src="item.ImgUrlList[1]"
                alt="picture"
              />
              <img class="img block" v-else :src="item.ImgUrl" alt="picture" />

              <div
                class="no_ddeliver"
                :style="fromHomeSale ? 'top:110px' : ''"
                v-if="item.NoDeliveryTip"
              >
                <span class="no_deliver_msg">{{ item.NoDeliveryTip }}</span>
              </div>

              <div
                class="discount"
                v-if="
                  !fromShopCart &&
                  isShowDiscount(item.DiscountRate) &&
                  [
                    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
                    80, 85, 90, 95,
                  ].indexOf(item.DiscountRate) > -1
                "
              >
                <img
                  :src="
                    require('../assets/icon/product-icon/discount_' +
                      (100 - item.DiscountRate) +
                      '.png')
                  "
                  class="discount_img"
                  :title="$t('productList.discount')"
                  v-if="item.DiscountRate > 0"
                />
              </div>
              <!-- ================================================ -->
              <div class="newbox">
                <div class="biaoshi">
                  <!-- isEperSelects -->
                  <!-- {{item.isEperSelects}} -->
                  <img
                    class="bsSize"
                    v-if="item.IsEperSelects"
                    src="../assets/icon/product-icon/a_1.png"
                    alt=""
                  />
                  <!-- isEperFarm -->
                  <img
                    class="bsSize"
                    v-if="item.IsEperFarm"
                    src="../assets/icon/product-icon/a_2.png"
                    alt=""
                  />
                  <!-- isEperKitchen -->
                  <img
                    class="bsSize"
                    v-if="item.IsEperKitchen"
                    src="../assets/icon/product-icon/a_3.png"
                    alt=""
                  />
                </div>

                <div
                  class="low-pricet"
                  v-if="!fromShopCart && item.IsLowPrice == true"
                >
                  <!-- icon_ch_lpldpi.png -->
                  <img
                    src="../assets/icon/product-icon/icon_ch_en1.png"
                    class="ch_img"
                    :title="$t('productList.lowerPrice')"
                    v-if="lang == 1"
                  />
                  <!-- icon_ch_en.png -->
                  <img
                    src="../assets/icon/product-icon/icon_ch_en1.png"
                    class="ch_img"
                    :title="$t('productList.lowerPrice')"
                    v-else
                  />
                </div>

                <div
                  class="icon_js"
                  v-if="!fromShopCart && item.IsHB"
                  :class="fromHomeSale ? 'js_top' : ''"
                >
                  <!-- v-if="!fromShopCart && item.isHB" -->

                  <img
                    src="../assets/icon/product-icon/jishi_ch.png"
                    class="js_img"
                    :title="$t('productList.quality')"
                    v-if="lang == 1"
                  />
                  <img
                    src="../assets/icon/product-icon/jishi_en.png"
                    class="js_img"
                    :title="$t('productList.quality')"
                    v-else-if="lang == 2"
                  />
                  <img
                    src="../assets/icon/product-icon/jishi_fr.png"
                    class="js_img"
                    :title="$t('productList.quality')"
                    v-else
                  />
                </div>
              </div>
              <!-- ================================================ -->

              <div
                class="quality"
                :class="lang == 1 ? '' : 'enQuality'"
                v-if="!fromShopCart && item.IsHighQuality"
              >
                <img
                  src="../assets/icon/product-icon/eper_quality_zh.png"
                  class="quality_img"
                  :title="$t('productList.quality')"
                  v-if="lang == 1"
                />
                <img
                  src="../assets/icon/product-icon/eper_quality_en.png"
                  class="quality_img"
                  :title="$t('productList.quality')"
                  v-else-if="lang == 2"
                />
                <img
                  src="../assets/icon/product-icon/eper_quality_fr.png"
                  class="quality_img"
                  :title="$t('productList.quality')"
                  v-else
                />
              </div>
              <div
                class="limittime"
                v-if="
                  !fromShopCart &&
                  item.IsLimitTime == true &&
                  [
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                    18, 19, 20, 21, 22, 23, 24,
                  ].indexOf(item.LimitHour) > -1
                "
              >
                <img
                  :src="
                    require('../assets/icon/product-icon/time_' +
                      item.LimitHour +
                      '.png')
                  "
                  :title="$t('productList.limittime')"
                  class="limittime_img"
                />
              </div>
              <div
                class="exclusive"
                v-if="!fromShopCart && item.IsExclusive == true"
              >
                <img
                  src="../assets/icon/product-icon/exclusive_zh.png"
                  class="exclusive_img"
                  :title="$t('productList.exclusive')"
                  v-if="lang == 1"
                />
                <img
                  src="../assets/icon/product-icon/exclusive_en.png"
                  class="exclusive_img"
                  :title="$t('productList.exclusive')"
                  v-else
                />
              </div>
              <div class="icon" v-if="!fromShopCart">
                <img
                  src="../assets/icon/product-icon/icon_green_vmdpi.png"
                  class="img"
                  :title="$t('productList.vegetarian')"
                  v-if="item.IsVegetarian"
                />
                <img
                  src="../assets/icon/product-icon/icon_green_gmdpi.png"
                  class="img"
                  :title="$t('productList.glutenFree')"
                  v-if="item.IsGlutenFree"
                />
                <img
                  src="../assets/icon/product-icon/icon_green_smdpi.png"
                  class="img"
                  :title="$t('productList.nosugar')"
                  v-if="item.IsSugarFree"
                />
                <img
                  src="../assets/icon/product-icon/icon_green_biomdpi.png"
                  class="img"
                  :title="$t('productList.organic')"
                  v-if="item.IsOrganic"
                />
                <img
                  src="../assets/icon/product-icon/icon_green_hmdpi.png"
                  class="img"
                  :title="$t('productList.muslim')"
                  v-if="item.IsMuslim"
                />
                <img
                  src="../assets/icon/product-icon/icon_tem_4.png"
                  class="img"
                  :title="$t('productList.temperaAttr')"
                  v-if="item.IsColdStorage"
                />
                <img
                  src="../assets/icon/product-icon/icon_tem_18.png"
                  class="img"
                  :title="$t('productList.frozen')"
                  v-if="item.IsFrozen"
                />
                <img
                  src="../assets/icon/product-icon/icon_isInstable.png"
                  class="img"
                  :title="$t('productList.instable')"
                  v-if="item.IsInstable"
                />
                <img
                  src="../assets/icon/product-icon/icon_delivery_thirdmdpi.png"
                  class="img"
                  :title="$t('productList.thirdDistribution')"
                  v-if="item.IsThirdDistribution"
                />
              </div>
            </div>
            <div class="pruduct-discription">
              <div v-if="!fromShopCart">
                <p class="pruduct-discription-brandName">
                  {{ item.BrandName ? item.BrandName : "" }}
                </p>
                <p
                  class="pruduct-discription-name"
                  @click.stop="toDetail(item)"
                  v-if="!fromShopCart"
                  :title="item.ProductName"
                >
                  {{ item.ProductName }}
                </p>

                <p class="pruduct-discription-prompt" v-if="item.ProType == 1 && item.IsCanBuy">
                  {{ $t("productList.sale_new") }}
                </p>
                <p
                  class="pruduct-discription-prompt"
                  v-else-if="item.ProType == 2 && item.IsCanBuy"
                >
                  {{ $t("productList.halffare") }}
                </p>
                <p
                  class="pruduct-discription-prompt"
                  v-else-if="item.ProType == 3 && item.IsCanBuy"
                >
                  {{ $t("productList.Fivefold") }}
                </p>
                <p
                  class="pruduct-discription-prompt"
                  v-else-if="item.IsNew && item.IsCanBuy"
                >
                  {{ $t("productList.new_arrival") }}
                </p>
                <p
                  class="pruduct-discription-prompt"
                  v-else-if="
                    item.SubTitle && item.SubTitle != '' && item.IsCanBuy
                  "
                >
                  {{ item.SubTitle }}
                </p>

                <p
                  class="pruduct-discription-prompt ellipsis"
                  v-else-if="item.Intro && item.Intro != '' && item.IsCanBuy"
                >
                  {{ item.Intro }}
                </p>
                <p
                  class="pruduct-discription-prompt"
                  v-else-if="item.ProType == 0 && item.IsCanBuy"
                ></p>
                <p
                  class="pruduct-discription-prompt"
                  v-else-if="fromShopCartForget && !item.IsCanBuy"
                ></p>
                <p
                  class="pruduct-discription-prompt"
                  v-else-if="fromCollection"
                ></p>
                <p class="pruduct-discription-prompt" v-else-if="isEperbox"></p>

                <p
                  class="pruduct-discription-prompt"
                  v-else
                  v-show="item.IsCanBuy"
                ></p>
                <p class="pruduct-discription-origin">
                  <template v-if="(item.PCountryName || item.ProduceCountryName) && item.IsCanBuy">{{ $t("productList.chandi2") }}: {{ item.PCountryName? item.PCountryName:item.ProduceCountryName}}</template>
                </p>
                <p
                  class="pruduct-discription-origin"
                  v-if="item.IsCanBuy && !fromRedwine && !fromShopCart"
                >
                  <template v-if="item.Origin && item.IsCanBuy"
                    >{{ (item.PCountryName || item.ProduceCountryName) ? $t("productList.chandi1") : $t("productList.chandi") }}: {{ item.Origin }}</template
                  >
                  <!-- </p>
            <p class="pruduct-discription-origin" v-if="fromHomeSale">
              <template v-if="item.ProArea">{{$t('productList.chandi')}}: {{item.ProArea}}</template>
                </p>-->
                </p>
                <p
                  class="pruduct-discription-origin"
                  v-else-if="fromSale && !item.IsCanBuy"
                >
                  <template v-if="item.Origin"
                    >{{ (item.PCountryName || item.ProduceCountryName) ? $t("productList.chandi1") : $t("productList.chandi") }}: {{ item.Origin }}</template
                  >
                </p>
                <p
                  class="pruduct-discription-origin"
                  v-else-if="fromRedwine && !item.Origin"
                ></p>
                <p
                  class="pruduct-discription-origin"
                  v-else-if="fromRedwine && item.Origin"
                >
                  <template v-if="item.Origin"
                    >{{ (item.PCountryName || item.ProduceCountryName) ? $t("productList.chandi1") : $t("productList.chandi") }}: {{ item.Origin }}</template
                  >
                </p>
                <p
                  class="pruduct-discription-origin"
                  v-else-if="fromShopCartForget && !item.IsCanBuy"
                >
                  {{ (item.PCountryName || item.ProduceCountryName) ? $t("productList.chandi1") : $t("productList.chandi") }}: {{ item.Origin }}
                </p>
                <p
                  class="pruduct-discription-origin"
                  v-else-if="fromCollection"
                ></p>
                <p class="pruduct-discription-origin" v-else-if="isEperbox"></p>

                <p
                  class="pruduct-discription-origin"
                  v-else
                  v-show="item.IsCanBuy"
                ></p>
                <p
                  class="pruduct-discription-remiand"
                  v-if="
                    !item.IsCanBuy &&
                    (isList ||
                      fromSearch ||
                      (fromHomeSale && !isEperbox) ||
                      fromProductDetail)
                  "
                >
                  {{ $t("productList.comesoon") }}
                </p>
                <p
                  class="pruduct-discription-similar"
                  v-if="
                    !item.IsCanBuy &&
                    (isList || fromRedwine || fromSearch || fromProductDetail)
                  "
                  @click="showSimilar(k, item.ProductID)"
                >
                  {{ $t("shopCart.similar_text") }}
                </p>
              </div>
              <div class="pruduct-discription-all ovh">
                <span
                  :class="[
                    'price',
                    'fl',
                    item.ProType
                      ? 'red'
                      : Number(item.MarketPrice) > Number(item.Price)
                      ? 'red'
                      : 'green',
                  ]"
                  v-if="item.Price > 0 && item.IsCanBuy"
                  >￥{{ item.Price }}</span
                >
                <span v-else-if="isEperbox" class="price fl green"
                  >￥{{ item.Price }}</span
                >
                <span
                  v-else
                  class="price fl"
                  style="color: #999; margin-top: 7px"
                  >￥{{ item.Price }}</span
                >
                <span
                  class="origin-price"
                  :style="!item.IsCanBuy && isList ? 'margin-top:3px' : ''"
                  v-if="
                    Number(item.MarketPrice) > Number(item.Price) &&
                    !fromShopCart
                  "
                  >￥{{ item.MarketPrice }}</span
                >
                <div
                  v-if="item.IsCanBuy && !multipleChoice"
                  class="shopping-cart fr"
                  @click.stop="ShowPopup(item)"
                >
                  <img
                    v-if="fromShopCart"
                    src="../assets/icon/shopcart_small.png"
                    class="img"
                  />
                  <img
                    v-else-if="fromHomeSale"
                    style="margin-top: 1px"
                    src="../assets/icon/shopcart_big.png"
                    class="img"
                  />
                  <img
                    v-else
                    style="margin-top: 5px"
                    src="../assets/icon/shopcart_mid.png"
                    class="img"
                  />
                </div>
                <div v-if="multipleChoice" class="shopping-cart fr">
                  <Radio :label="item.ProductID"><span></span></Radio>
                </div>
                <!-- <div class="shopping-cart fr" v-if="fromHomeSale" @click.stop="addCart(item, item.ProductID,item.isCanBuy)">
                <img src="../assets/icon/shoping-cart.png" class="img">
              </div>
               <div class="shopping-cart fr" v-if="fromSale && !item.isCanBuy " @click.stop="addCart(item, item.ProductID,item.isCanBuy)">
                <img src="../assets/icon/shoping-cart.png" class="img">
              </div>-->
              </div>
            </div>
            <div
              class="mask"
              v-if="item.IsCanBuy == false && fromCollection == true"
            ></div>
            <div
              class="deleteCollect"
              v-if="fromCollection == true"
              @click="deleteCollect(item.ProductID)"
            >
              ×
            </div>
            <div
              class="similarPro"
              :style="{ left: similarProLeft + 'px' }"
              v-if="!item.IsCanBuy && isShow && showIndex == k"
            >
              <span
                class="green-arrow"
                :style="{ left: similarProGreen + 'px' }"
              ></span>
              <span
                class="white-arrow"
                :style="{ left: similarProWhile + 'px' }"
              ></span>
              <img
                class="similar-close"
                src="../assets/close-quick.png"
                alt
                @click="closeSimilar"
              />
              <p class="title">{{ $t("productList.below") }}</p>
              <ul class="similar-product clearfix">
                <li
                  class="similar-item fl"
                  v-for="(item, index) in similarList"
                  :key="index"
                >
                  <div class="similar-img-box public-ul-li-pictrue">
                    <div
                      class="low-price"
                      v-if="!fromShopCart && item.isLowPrice == true"
                    >
                      <!-- icon_ch_lpldpi.png -->
                      <img
                        src="../assets/icon/product-icon/icon_ch_en1.png"
                        class="ch_img"
                        :title="$t('productList.lowerPrice')"
                        v-if="lang == 1"
                      />
                      <!-- icon_ch_en.png -->
                      <img
                        src="../assets/icon/product-icon/icon_ch_en1.png"
                        class="ch_img"
                        :title="$t('productList.lowerPrice')"
                        v-else
                      />
                    </div>
                    <div
                      class="discount"
                      v-if="
                        !fromShopCart &&
                        isShowDiscount(item.DiscountRate) &&
                        [
                          5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70,
                          75, 80, 85, 90, 95,
                        ].indexOf(item.DiscountRate) > -1
                      "
                    >
                      <img
                        :src="
                          require('../assets/icon/product-icon/discount_' +
                            (100 - item.DiscountRate) +
                            '.png')
                        "
                        class="discount_img"
                        :title="$t('productList.discount')"
                        v-if="item.DiscountRate > 0"
                      />
                    </div>
                    <div
                      class="quality"
                      v-if="!fromShopCart && item.isHighQuailty"
                    >
                      <img
                        src="../assets/icon/product-icon/eper_quality_zh.png"
                        class="quality_img"
                        :title="$t('productList.quality')"
                        v-if="lang == 1"
                      />
                      <img
                        src="../assets/icon/product-icon/eper_quality_en.png"
                        class="quality_img"
                        :title="$t('productList.quality')"
                        v-else
                      />
                    </div>
                    <div
                      class="limittime"
                      v-if="
                        !fromShopCart &&
                        item.isLimitTime == true &&
                        [
                          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                          17, 18, 19, 20, 21, 22, 23, 24,
                        ].indexOf(item.LimitTime) > -1
                      "
                    >
                      <img
                        :src="
                          require('../assets/icon/product-icon/time_' +
                            item.LimitTime +
                            '.png')
                        "
                        :title="$t('productList.limittime')"
                        class="limittime_img"
                      />
                    </div>
                    <div
                      class="exclusive"
                      v-if="!fromShopCart && item.isExclusive == true"
                    >
                      <img
                        src="../assets/icon/product-icon/exclusive_zh.png"
                        class="exclusive_img"
                        :title="$t('productList.exclusive')"
                        v-if="lang == 1"
                      />
                      <img
                        src="../assets/icon/product-icon/exclusive_en.png"
                        class="exclusive_img"
                        :title="$t('productList.exclusive')"
                        v-else
                      />
                    </div>
                    <div class="icon">
                      <img
                        src="../assets/icon/product-icon/icon_green_vmdpi.png"
                        class="img"
                        :title="$t('productList.vegetarian')"
                        v-if="item.isvegetarian"
                      />
                      <img
                        src="../assets/icon/product-icon/icon_green_gmdpi.png"
                        class="img"
                        :title="$t('productList.glutenFree')"
                        v-if="item.isGlutenFree"
                      />
                      <img
                        src="../assets/icon/product-icon/icon_green_smdpi.png"
                        class="img"
                        :title="$t('productList.sugerFree')"
                        v-if="item.isSugerFree"
                      />
                      <img
                        src="../assets/icon/product-icon/icon_green_biomdpi.png"
                        class="img"
                        :title="lang == 1 ? '' : $t('productList.organic')"
                        v-if="item.isOrganic"
                      />
                      <img
                        src="../assets/icon/product-icon/icon_green_hmdpi.png"
                        class="img"
                        :title="$t('productList.muslim')"
                        v-if="item.isMuslim"
                      />
                      <img
                        src="../assets/icon/product-icon/icon_tem_4.png"
                        class="img"
                        :title="$t('productList.temperaAttr')"
                        v-if="item.isTemperaAttr"
                      />
                      <img
                        src="../assets/icon/product-icon/icon_tem_18.png"
                        class="img"
                        :title="$t('productList.frozen')"
                        v-if="item.isFrozen"
                      />
                      <img
                        src="../assets/icon/product-icon/icon_isInstable.png"
                        class="img"
                        :title="$t('productList.instable')"
                        v-if="item.isInstable"
                      />
                      <img
                        src="../assets/icon/product-icon/icon_delivery_thirdmdpi.png"
                        class="img"
                        :title="$t('productList.thirdDistribution')"
                        v-if="item.isThirdDistribution"
                      />
                    </div>
                    <img
                      class="similar-img"
                      :src="item.Pic"
                      alt
                      @click="toDetail(item)"
                    />
                  </div>
                  <div class="pruduct-discription">
                    <p class="pruduct-discription-brandName">
                      {{ item.BrandName ? item.BrandName : "" }}
                    </p>
                    <p class="pruduct-discription-name">
                      {{ item.ProductName }}
                    </p>
                    <p data-v-f2bcec66 class="pruduct-discription-prompt"></p>
                    <p class="pruduct-discription-origin">
                      <template v-if="item.PCountryName || item.ProduceCountryName">{{ $t("productList.chandi2") }}: {{ item.PCountryName? item.PCountryName:item.ProduceCountryName}}</template>
                    </p>
                    <p class="pruduct-discription-origin" >
                      <template v-if="item.ProArea">{{ (item.PCountryName || item.ProduceCountryName) ? $t("productList.chandi1") : $t("productList.chandi") }}: {{ item.ProArea }}</template>
                    </p>
                    <div class="pruduct-discription-all ovh">
                      <!-- <p class="price fl green">￥{{ item.Price | toFix }}</p> -->
                      <span :class="['price','fl',item.ProType ? 'red' : Number(item.MarkPrice) > Number(item.Price) ? 'red' : 'green',]" v-if="item.Price > 0 && item.isCanBuy">￥{{ item.Price }}</span>
                      <span v-else-if="isEperbox" class="price fl green">￥{{ item.Price }}</span>
                      <span v-else class="price fl" style="color: #999; margin-top: 7px">￥{{ item.Price }}</span>
                      <span class="origin-price" :style="!item.isCanBuy && isList ? 'margin-top:3px' : ''" v-if="Number(item.MarkPrice) > Number(item.Price) && !fromShopCart">￥{{ item.MarkPrice }}</span>


                      <div
                        class="shopping-cart fr"
                        v-if="item.IsCanBuy"
                        @click.stop="
                          addCart(item, item.ProductID, item.IsCanBuy)
                        "
                      >
                        <!-- <img src="../assets/icon/shoping-cart.png" class="img" /> -->
                        <img
                          v-if="fromShopCart"
                          src="../assets/icon/shopcart_small.png"
                          class="img"
                        />
                        <img
                          v-else-if="fromHomeSale"
                          style="margin-top: 1px"
                          src="../assets/icon/shopcart_big.png"
                          class="img"
                        />
                        <img
                          v-else
                          style="margin-top: 5px"
                          src="../assets/icon/shopcart_mid.png"
                          class="img"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <p class="bottom-title">{{ $t("productList.similarProBtm") }}</p>
              <p class="remindBtn" @click.stop="remind(item.ProductID)">
                {{ $t("productList.remind") }}
              </p>
            </div>
          </li>
        </RadioGroup>
      </ul>
    </div>
    <!-- isShowVIP 是否显示vip -->
    <!-- <vipbox v-on:closeVip="closeVip" v-if="isShowVIP"></vipbox> -->
  </div>
</template>

<script>
import filter from "../plugins/filters";
// import vipbox from "../components/public/Vipbox.vue"
export default {
  name: "productList",
  components: {
    // vipbox
  },
  props: {
    isCart: {
      type: Boolean,
      default: false,
    },
    productList: {
      type: Array,
      default: () => [],
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    len: {
      type: Number,
      default: 0,
    },
    liw: {
      type: Number,
      default: 0,
    },
    fromCollection: {
      type: Boolean,
      default: false,
    },
    fromShopCart: {
      type: Boolean,
      default: false,
    },
    // 是否是商品列表页
    isList: {
      type: Boolean,
      default: false,
    },
    fromRedwine: {
      type: Boolean,
      default: false,
    },
    fromShopCartForget: {
      type: Boolean,
      default: false,
    },
    fromHomeSale: {
      type: Boolean,
      default: false,
    },
    isEperbox: {
      type: Boolean,
      default: false,
    },
    fromSale: {
      type: Boolean,
      default: false,
    },
    fromProductDetail: {
      type: Boolean,
      default: false,
    },
    fromSearch: {
      type: Boolean,
      default: false,
    },
    noAd: {
      type: Boolean,
      default: true,
    },
    IsPopup: {
      //是否需要多规格弹窗
      type: Boolean,
      default: true,
    },
    multipleChoice: {
      type: Boolean,
      default: false,
    },
    isClick: {
      //是否可以进入详情页
      type: Boolean,
      default: true, //默认可以
    },
    inspectIsAddCart: {
      //是否需要检查能否加入购物车
      type: Boolean,
      default: false, //默认不需要
    },
    GiftProductID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      similarProLeft: 0,
      similarProWhile: 80,
      similarProGreen: 79,
      lang: 1,
      isSuccess: false,
      cartNum: "",
      indexCartPro: {},
      token: filter.readData("userInfo")
        ? filter.readData("userInfo").Token
        : "",
      isShow: false,
      showIndex: "",
      similarList: [{}, {}, {}, {}],
      isShowVIP: false,
      ProductID: 0,
    };
  },
  mounted() {
    if (this.GiftProductID) this.ProductID = this.GiftProductID;
    this.lang = localStorage.getItem("lang");
    if (this.len) {
      this.$nextTick(() => {
        this.$refs.ulRef.style.width =
          Number(this.len) * Number(this.liw) + "px";
      });
    }
  },
  filters: {
    toFix(v) {
      if (v) {
        return Number(v).toFixed(2);
      }
      return v;
    },
  },
  methods: {
    changeGiftProduct(e) {
      this.$emit("changeGiftProduct", e);
    },
    closeVip(val) {
      this.isShowVIP = val;
    },
    toDetail(val) {
      if (val.PromWebFunctionID) {
        return;
      }
      if (!this.isClick) {
        return;
      }
      if (this.isEperbox) {
        if (this.token) {
          this.$router.push({
            path: "/eperBoxDetail",
            query: { proid: val.ProductID, ProTitle: val.ProductName },
          });
        } else {
          alert("" + this.$t("headerNav.hint_noLogin"));
          this.$router.replace({
            path: "/login",
            query: {
              redirectUrl: this.$route.fullPath,
            },
          });
        }

        return;
      }
      if (val.ProType != 3 || !val.PromotionID) {
        // this.$router.push({
        //   path: "/productDetail",
        //   query: { id: val.ProductID, ProductCataID: val.ProductCataID },
        // });
        window.open(
          "/productDetail?id=" +
            val.ProductID +
            "&ProductCataID=" +
            val.ProductCataID,
          "_blank"
        );
      }
    },
    showMorePic(idx) {
      this.productList[idx].showMore = true;
      this.$forceUpdate();
    },
    hideMorePic(idx) {
      delete this.productList[idx].showMore;
      this.$forceUpdate();
    },
    toSale() {
      this.$router.push("/sale");
    },
    // 查询是否有多规格信息
    ShowPopup(item) {
      if (this.IsPopup) {
        const { CityID } = JSON.parse(localStorage.getItem("cityInfo"));
        this.$store
          .dispatch("ShowBindingProductList", {
            ProductID: item.ProductID,
            CityID,
            isSign: true,
          })
          .then((res) => {
            if (
              res.Data.BindingProductList.length > 0 &&
              res.Data.BindingProductList.length < 3
            ) {
              let arr = res.Data.BindingProductList;
              arr.unshift(res.Data.MasterProduct);
              this.$ProductSpec(arr);
            } else if (res.Data.BindingProductList.length >= 3) {
              let arr = res.Data.BindingProductList;
              arr.splice(3);
              arr.unshift(res.Data.MasterProduct);
              this.$ProductSpec(arr);
            } else {
              this.addCart(item, item.ProductID, item.IsCanBuy);
            }
          });
      } else if (this.inspectIsAddCart) {
        this.$emit("inspectCart", item);
      } else {
        this.addCart(item, item.ProductID, item.IsCanBuy);
      }
    },
    addCart(product, id, canbuy) {
      //console.log(this.$store.state);
      const _this = this;
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      _this.$store
        .dispatch("AddToCart", {
          productid: id,
          num: 1,
          cartKind: product.PromotionID ? 0 : 1,
          ckValue: product.PromotionID ? product.PromotionID : "",
          TempId,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
          PromWebFunctionID: _this.$store.state.PromWebFunctionID
            ? _this.$store.state.PromWebFunctionID
            : "",
        })
        .then((res) => {
          if (res.Code == 200) {
            if (canbuy == false) {
              alert("" + this.$t("productList.inventory"));
              return;
            }
            switch (res.Data.Tip) {
              case 104:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 105:
                // 此商品购买数量不可超过50
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 106:
                // 购买数量不能超过促销活动单笔限购数量
                alert("" + this.$t("hint.outBuyNum"));
                break;
              case 107:
                // 购买数量不能超过促销活动单笔限购数量
                alert("" + this.$t("hint.outBuyNum"));
                break;
              case 108:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 210:
                // 库存不足!
                alert("" + this.$t("productList.inventory"));
                break;
              case 211:
                // 商品不存在
                alert("" + this.$t("addcartMessage.mes8"));
                break;
              case 212:
                // 已过期
                alert("" + this.$t("addcartMessage.mes1"));
                break;
              case 213:
                // 重复参加该促销活动！
                alert("" + this.$t("addcartMessage.mes9"));
                break;
              case 214:
                // 不符合条件！
                alert("" + this.$t("addcartMessage.mes10"));
                break;
              case 215:
                // 已下架
                alert("" + this.$t("addcartMessage.mes11"));
                break;
              case 216:
                // 此商品购买数量不可超过50
                alert("" + this.$t("addcartMessage.mes7"));
                break;
              case 217:
                // 你还未登录
                alert("" + this.$t("headerNav.hint_noLogin"));
                this.$router.replace({
                  path: "/login",
                  query: {
                    redirectUrl: this.$route.fullPath,
                  },
                });
                break;
              case 218:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 220:
                // 您尚未达到会员级别
                alert("" + this.$t("CouponVersion.CouponVersion37"));
                break;
              case 222:
                // 购物车选择赠品
                break;
              case 223:
                //赠品加入购物车不满足条件
                alert("" + this.$t("CouponVersion.CouponVersion32"));
                break;
              case 224:
                //因为优惠券到期导致优惠券下的商品无法加入购物车
                alert("" + this.$t("CouponVersion.CouponVersion33"));
                break;
              case 225:
                //活动限于第xx单客户
                // alert("" + this.$t("CouponVersion.CouponVersion33"));
                break;
            }
            // if (res.Data.Tip == 106) {
            //   alert("" + this.$t("hint.outBuyNum"));
            // }
            // if (res.Data.ShopCartProductID==0 && res.Data.Tip != 106){
            //   alert("" + this.$t("headerNav.hint_noLogin"));
            //   this.$router.replace({
            //     path: "/login",
            //     query: {
            //       redirectUrl: this.$route.fullPath,
            //     },
            //   });
            //   return ;
            // }
            // if(res.Data.Tip==0 && _this.$store.state.PromWebFunctionID){

            // }
            /* 
                212活动过期
                217未登录
                220有会员限制
                108购买的数量超过库存量
                106购买数量不能超过促销活动 单笔限购数量
                218，104超出限购数量；
                215下架；
                210缺货库存不足
            */
            // alert(''+this.$t('productList.succ'));
            if (!_this.isCart) {
              _this.GetCartPros(res.Data.Tip);
            } else {
              _this.eventBus.$emit("addCartEvt");
            }
          }
        });
    },
    //删除收藏商品
    deleteCollect(id) {
      let _this = this;
      _this.$emit("delect-collect", { id: id });
    },
    // 获取购物车商品
    GetCartPros(Tip) {
      const _this = this;
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      _this.$store
        .dispatch("GetCartPros", {
          TempId,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then(({ Data }) => {
          this.$store.commit("setShopCar", Data);

          if (Tip == 0) {
            this.$store.commit("needShowCartToSeconds", true);
          } else {
            this.$store.commit("needShowCartToSeconds", false);
          }
          this.eventBus.$emit("addCartEvt");
        });
    },
    showSimilar(index, id) {
      //console.log(index);
      let num = this.noAd ? 5 : 4;
      var lastShowIdx = this.showIndex;
      this.showIndex = index;
      this.similarProLeft = [0, -210, -420, -630, -700][index % num];
      this.similarProWhile = [80, 290, 500, 710, 780][index % num];
      this.similarProGreen = [79, 289, 499, 709, 779][index % num];
      if (lastShowIdx != index && this.isShow) {
        this.isShow = !this.isShow;
        this.isShow = !this.isShow;
      } else {
        this.isShow = !this.isShow;
      }

      // 获取缺货商品的相似商品
      if (this.isShow) {
        this.$store
          .dispatch("GetGoodLikePros", {
            productid: id,
            Token: localStorage.getItem("Token")
              ? localStorage.getItem("Token")
              : "",
          })
          .then((res) => {
            this.similarList = res.Data;
          });
      }
    },
    closeSimilar() {
      this.isShow = false;
    },
    isShowDiscount(discount) {
      let discounts = [
        5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
        95, 100,
      ];
      if (discounts.indexOf(discount) >= 0) {
        return true;
      }
      return false;
    },
    // 到货提醒
    remind(id) {
      if (!this.token) {
        alert("" + this.$t("headerNav.hint_noLogin"));
        this.$router.push({
          path: "/login",
        });
      } else {
        this.$store
          .dispatch("SetArrivalNotice", {
            productid: id,
            Token: localStorage.getItem("Token")
              ? localStorage.getItem("Token")
              : "",
          })
          .then((res) => {
            if (res.Code == 200) {
              alert("" + this.$t("hint.hint_remind"));
            }
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/NewproductList.vue